export enum ReportType { Rank = 'RANK'}
